import { Product } from '../types';

// A permission set that hides Product serves it with every field null, which reads as blank rather than "null - null".
export const productLabel = (
  product: Partial<Product> | null | undefined,
  { abbreviated = true }: { abbreviated?: boolean } = {}
): string => {
  if (!product) return 'Other';
  const name = abbreviated ? product.nameAbbreviation || product.name : product.name;
  return name ? `${product.family} - ${name}` : '';
};
